import $ from 'jquery';

import {
    HOME_PAGE,
    DETAILS_PAGE,
    RESULTS_PAGE,
    ORDER_PAGE,
    CREDIT_CARD_PAGE,
    CONFIRMATION_PAGE
} from '@lts-web/types/PageNames';
import PageContext from '@lts-web/data-objects/PageContext';
import GlobalObject from '@lts-web/registry/GlobalObject';

$.PageModule = {
    HOME_PAGE() {
        return HOME_PAGE;
    },
    DETAILS_PAGE() {
        return DETAILS_PAGE;
    },
    RESULTS_PAGE() {
        return RESULTS_PAGE;
    },
    ORDER_PAGE() {
        return ORDER_PAGE;
    },
    CREDIT_CARD_PAGE() {
        return CREDIT_CARD_PAGE;
    },
    CONFIRMATION_PAGE() {
        return CONFIRMATION_PAGE;
    }
};

GlobalObject.getInstance().define('pageContext', {
    value: new PageContext(),
    writable: false,
    enumerable: false,
    configurable: false
});

global.pageModuleInstance = GlobalObject.getInstance().get('pageContext');